// 购物车抽屉产品列表功能
class CartDrawerProductList {
  constructor() {
    this.init();
  }

  init() {
    // 当DOM加载完成后初始化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // 绑定变体选择器和添加按钮事件
    document.addEventListener("click", (e) => {
      if (e.target.matches(".cart-drawer__product-list-item-variant-button")) {
        this.handleAddToCart(e);
      }
    });

    document.addEventListener("change", (e) => {
      if (e.target.matches(".cart-drawer__product-list-item-variant-select")) {
        this.handleVariantChange(e);
      }
    });

    // 初始化所有产品项的状态
    this.initializeProductItems();
  }

  initializeProductItems() {
    const productItems = document.querySelectorAll(
      ".cart-drawer__product-list-item"
    );

    productItems.forEach((item) => {
      const variantSelect = item.querySelector(
        ".cart-drawer__product-list-item-variant-select"
      );
      const button = item.querySelector(
        ".cart-drawer__product-list-item-variant-button"
      );
      const priceElement = item.querySelector(
        ".cart-drawer__product-list-item-info-price"
      );

      if (variantSelect && button) {
        // 确保按钮始终启用且显示正确文本
        button.disabled = false;
        button.textContent = "Add";

        // 如果选择器有选项但没有选择值，自动选择第一个
        if (!variantSelect.value && variantSelect.options.length > 0) {
          const firstOption = variantSelect.options[0];
          if (firstOption && firstOption.value) {
            variantSelect.value = firstOption.value;

            // 更新价格显示
            const price = firstOption.getAttribute("data-price");
            const comparePrice = firstOption.getAttribute("data-compare-price");

            if (price && priceElement) {
              this.updatePriceDisplay(priceElement, price, comparePrice);
            }
          }
        }
      }
    });
  }

  async handleAddToCart(event) {
    event.preventDefault();

    const button = event.target;
    const productItem = button.closest(".cart-drawer__product-list-item");
    const variantSelect = productItem.querySelector(
      ".cart-drawer__product-list-item-variant-select"
    );

    let variantId = variantSelect.value;

    // 如果没有选择变体，自动选择第一个变体
    if (!variantId && variantSelect.options.length > 0) {
      const firstOption = variantSelect.options[0];
      if (firstOption && firstOption.value) {
        variantId = firstOption.value;
        variantSelect.value = variantId;
      } else {
        this.showError("该产品暂时无法购买");
        return;
      }
    }

    // 设置加载状态
    this.setLoadingState(button, true);

    try {
      // 添加到购物车
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "添加到购物车失败");
      }

      const result = await response.json();

      // 更新购物车抽屉
      await this.refreshCartDrawer();

      // 显示成功消息
      this.showSuccess("Product successfully added to cart");
    } catch (error) {
      console.error("添加到购物车时出错:", error);
      this.showError(error.message || "添加到购物车失败，请重试");
    } finally {
      // 移除加载状态
      this.setLoadingState(button, false);
    }
  }

  handleVariantChange(event) {
    const select = event.target;
    const productItem = select.closest(".cart-drawer__product-list-item");
    const button = productItem.querySelector(
      ".cart-drawer__product-list-item-variant-button"
    );
    const priceElement = productItem.querySelector(
      ".cart-drawer__product-list-item-info-price"
    );

    // 按钮始终保持启用状态，文本始终显示"Add"
    button.disabled = false;
    button.textContent = "Add";

    // 更新价格显示
    if (select.value) {
      const selectedOption = select.options[select.selectedIndex];
      const price = selectedOption.getAttribute("data-price");
      const comparePrice = selectedOption.getAttribute("data-compare-price");

      if (price && priceElement) {
        this.updatePriceDisplay(priceElement, price, comparePrice);
      }
    }
  }

  updatePriceDisplay(priceElement, price, comparePrice) {
    const formatPrice = (cents) => {
      return new Intl.NumberFormat("zh-CN", {
        style: "currency",
        currency: "CNY",
        minimumFractionDigits: 2,
      }).format(cents / 100);
    };

    let priceHtml = "";

    if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
      // 有促销价格
      priceHtml = `
        <span class="price price--on-sale">
          <span class="price-item price-item--sale">${formatPrice(price)}</span>
          <span class="price-item price-item--regular">${formatPrice(
            comparePrice
          )}</span>
        </span>
      `;
    } else {
      // 正常价格
      priceHtml = `
        <span class="price">
          <span class="price-item">${formatPrice(price)}</span>
        </span>
      `;
    }

    priceElement.innerHTML = priceHtml;
  }

  async refreshCartDrawer() {
    try {
      // 获取更新后的购物车数据
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      // 更新购物车数量显示
      this.updateCartCount(cartData.item_count);

      // 如果购物车抽屉是打开的，更新其内容
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        // 更新抽屉状态
        if (cartData.item_count > 0) {
          cartDrawer.classList.remove("is-empty");
        }

        // 如果抽屉是打开的，刷新内容
        if (
          cartDrawer.classList.contains("active") ||
          cartDrawer.hasAttribute("open")
        ) {
          const drawerResponse = await fetch("/?section_id=cart-drawer");
          const drawerHtml = await drawerResponse.text();

          const parser = new DOMParser();
          const doc = parser.parseFromString(drawerHtml, "text/html");
          const newDrawerInner = doc.querySelector(".drawer__inner");

          if (newDrawerInner) {
            const currentDrawerInner =
              cartDrawer.querySelector(".drawer__inner");
            if (currentDrawerInner) {
              // 保存滚动位置
              const scrollContainer =
                cartDrawer.querySelector("cart-drawer-items");
              const scrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

              // 恢复滚动位置
              setTimeout(() => {
                const newScrollContainer =
                  cartDrawer.querySelector("cart-drawer-items");
                if (newScrollContainer) {
                  newScrollContainer.scrollTop = scrollTop;
                }
              }, 50);

              // 重新绑定产品列表事件
              this.bindProductListEvents();
            }
          }
        }
      }

      // 触发购物车更新事件
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart: cartData },
        })
      );
    } catch (error) {
      console.error("刷新购物车抽屉时出错:", error);
    }
  }

  bindProductListEvents() {
    // 重新绑定产品列表的事件监听器
    const variantSelects = document.querySelectorAll(
      ".cart-drawer__product-list-item-variant-select"
    );
    const addButtons = document.querySelectorAll(
      ".cart-drawer__product-list-item-variant-button"
    );

    variantSelects.forEach((select) => {
      // 移除旧的事件监听器（如果存在）
      select.removeEventListener("change", this.handleVariantChange);
      // 添加新的事件监听器
      select.addEventListener("change", this.handleVariantChange.bind(this));
    });

    addButtons.forEach((button) => {
      // 移除旧的事件监听器（如果存在）
      button.removeEventListener("click", this.handleAddToCart);
      // 添加新的事件监听器
      button.addEventListener("click", this.handleAddToCart.bind(this));
    });

    // 重新初始化所有产品项的状态
    this.initializeProductItems();
  }

  updateCartCount(count) {
    // 更新页面上的购物车数量显示
    const cartCountElements = document.querySelectorAll("[data-cart-count]");
    cartCountElements.forEach((element) => {
      element.textContent = count;
      element.setAttribute("data-cart-count", count);
    });

    // 更新购物车图标上的数量
    const cartBadges = document.querySelectorAll(".cart-count-bubble span");
    cartBadges.forEach((badge) => {
      badge.textContent = count;
    });
  }

  setLoadingState(button, isLoading) {
    if (isLoading) {
      button.classList.add("loading");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    } else {
      button.classList.remove("loading");
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }

  showSuccess(message) {
    this.showNotification(message, "success");
  }

  showError(message) {
    this.showNotification(message, "error");
  }

  showNotification(message, type = "info") {
    // 创建通知元素
    const notification = document.createElement("div");
    notification.className = `cart-drawer-notification cart-drawer-notification--${type}`;
    notification.innerHTML = `
      <div class="cart-drawer-notification__content">
        <span class="cart-drawer-notification__message">${message}</span>
        <button class="cart-drawer-notification__close" aria-label="关闭通知">
          <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    `;

    // 添加样式
    if (!document.querySelector("#cart-drawer-notification-styles")) {
      const styles = document.createElement("style");
      styles.id = "cart-drawer-notification-styles";
      styles.textContent = `
        .cart-drawer-notification {
          position: fixed;
          top: 2rem;
          right: 2rem;
          z-index: 9999;
          padding: 1rem 1.5rem;
          border-radius: 0.5rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transform: translateX(100%);
          transition: transform 0.3s ease;
          max-width: 30rem;
        }
        
        .cart-drawer-notification--success {
          background-color: #10b981;
          color: white;
        }
        
        .cart-drawer-notification--error {
          background-color: #ef4444;
          color: white;
        }
        
        .cart-drawer-notification--info {
          background-color: #3b82f6;
          color: white;
        }
        
        .cart-drawer-notification.show {
          transform: translateX(0);
        }
        
        .cart-drawer-notification__content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
        }
        
        .cart-drawer-notification__message {
          font-size: 1.4rem;
          font-weight: 500;
        }
        
        .cart-drawer-notification__close {
          background: none;
          border: none;
          color: inherit;
          cursor: pointer;
          padding: 0.2rem;
          border-radius: 0.25rem;
          transition: background-color 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .cart-drawer-notification__close:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      `;
      document.head.appendChild(styles);
    }

    // 添加到页面
    document.body.appendChild(notification);

    // 显示通知
    requestAnimationFrame(() => {
      notification.classList.add("show");
    });

    // 绑定关闭按钮事件
    const closeButton = notification.querySelector(
      ".cart-drawer-notification__close"
    );
    const closeNotification = () => {
      notification.classList.remove("show");
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    };

    closeButton.addEventListener("click", closeNotification);

    // 自动关闭
    setTimeout(closeNotification, 5000);
  }
}

// 初始化购物车抽屉产品列表
new CartDrawerProductList();
